/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
export const selectCurrentLoanDetails = (state: any) =>
  state.loanDetails.currentLoanDetails;
